import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";
import dayjs, { Dayjs } from "dayjs";
import { useSurveysResponseFilterStore } from "../../../../store/use-surveys-response-filter";
import {
  FilterDialogFooter,
  FilterDialogHeader,
  PillToggleButton,
} from "../../../users/components/filter_dialog/filter_dialog_parts";

export default function FilterChoices() {
  const {
    openChoicesModal,
    setOpenChoicesModal,
    incomeId,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    states,
    stateId,
    setStateId,
    resetFilter,
    genderList,
    selectedGender,
    setSelectedGender,
    occupation,
    education,
    income,
    occupationId,
    setOccupationId,
    educationId,
    setEducationId,
    setIncomeId,
    setFamilyIncomeId,
    currentTab,
    setApplyFilter
  } = useSurveysResponseFilterStore();


  const handleApplyClick=() => {
    setOpenChoicesModal(false)
    setApplyFilter(true)
  }


  const handleReset = () => {
    resetFilter();
    setApplyFilter(true)
    setOpenChoicesModal(false);
  };

  return (
    <Dialog open={openChoicesModal} onClose={() => setOpenChoicesModal(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
      <Box sx={{ width: 400, p: 2 }}>
        <FilterDialogHeader title="Filter Surveys" onClose={() => setOpenChoicesModal(false)} onReset={handleReset} />
        <Box sx={{ maxHeight: 400, overflow: "auto scroll" }}>
          <Typography fontSize={16} fontWeight="600" mb={1}>
            Gender
          </Typography>
          <Box>
            {genderList?.map((gender) => (
              <PillToggleButton
                key={gender.id}
                label={gender.value}
                active={selectedGender === gender.value}
                onClick={() =>
                  setSelectedGender(selectedGender === gender.value ? "" : gender.value)
                }
              />
            ))}
          </Box>

          <Divider sx={{ mt: 2, mb: 1 }} />

          {_dropdownOption({
            title: "State",
            placeholder: "Search for State",
            options: states,
            selectedId: stateId,
            onSelect: setStateId,
          })}
          {_dropdownOption({
            title: "Filter by Occupation",
            placeholder: "Search for Occupation",
            options: occupation,
            selectedId: occupationId,
            onSelect: setOccupationId,
          })}
          {_dropdownOption({
            title: "Filter by Education",
            placeholder: "Search for Education",
            options: education,
            selectedId: educationId,
            onSelect: setEducationId,
          })}
          {currentTab === 0 &&
            _dropdownOption({
              title: "Filter by Current Income",
              placeholder: "Search for Current Income",
              options: income,
              selectedId: incomeId,
              onSelect: setIncomeId,
            })}
          {currentTab === 1 &&
            _dropdownOption({
              title: "Filter by Family Income",
              placeholder: "Search for Family Income",
              options: income,
              selectedId: null,
              onSelect: setFamilyIncomeId,
            })}

          {_dateRange({
            title: "Date Range",
            setEndDate,
            setStartDate,
            startDate,
            endDate,
          })}

          <FilterDialogFooter onCancel={() => setOpenChoicesModal(false)} onApply={handleApplyClick} />
        </Box>
      </Box>
    </Dialog>
  );

  function _dropdownOption({
    title,
    placeholder,
    options,
    selectedId,
    onSelect,
  }: {
    title: string;
    placeholder: string;
    options: { id: number; value: string }[];
    selectedId: number | null;
    onSelect: (id: number | null) => void;
  }) {
    return (
      <Box pt={2} pb={1}>
        <Typography fontSize={16} fontWeight="600">
          {title}
        </Typography>
        <Box pt={1} pb={2} display="flex" flexDirection="row">
          <Autocomplete
            fullWidth
            value={options.find((option) => selectedId === option?.id) || null}
            onChange={(e, value) => onSelect(value?.id || null)}
            options={options}
            getOptionLabel={(option) => option?.value}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={placeholder}
                placeholder={placeholder}
              />
            )}
          />
        </Box>
        <Divider />
      </Box>
    );
  }

  function _dateRange({
    title,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  }: {
    title: string;
    startDate: string;
    setStartDate: (value: string) => void;
    endDate: string;
    setEndDate: (value: string) => void;
  }) {
    return (
      <Box pt={2} pb={1}>
        <Typography fontSize={16} fontWeight="600">
          {title}
        </Typography>
        <Box pt={1} pb={2} display="flex" flexDirection={"column"}>
          <DatePicker
            label="Start Date"
            format="DD-MM-YYYY"
            disableFuture
            value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
            onChange={(value: Dayjs | null) => {
              setStartDate(value?.format("YYYY-MM-DD") || "");
            }}
          />
          <Box p={1}></Box>
          <DatePicker
            label="End Date"
            format="DD-MM-YYYY"
            disableFuture
            value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
            onChange={(value: Dayjs | null) => {
              setEndDate(value?.format("YYYY-MM-DD") || "");
            }}
          />
        </Box>
      </Box>
    );
  }
}
